export default __webpack_public_path__ + "static/media/chj1.878f7c3c.jpg";